import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NotesService } from './service/notes.service';
import { NotesModel } from './model/notes.model';
import { Page } from '../../domain/model/common/search/page.class';
import moment = require('moment');

@Component({
    template: require('./notes-page.component.html'),
    styles: [require('../shared/section/section.component.scss'), require('./notes-page.component.scss')]
})
@Injectable()
export class NotesPageComponent implements OnDestroy, OnInit {
    private pageSize: number = 10;
    private subscriptions: Subscription;
    private userName: string = 'myself';
    public form: FormGroup;
    public hasErrors: boolean = false;
    public hasSavingError: boolean = false;
    public loading: boolean = false;
    public notes: Array<NotesModel> = [];
    public page?: Page<NotesModel>;
    public saving: boolean = false;

    constructor(
        readonly formBuilder: FormBuilder,
        readonly notesService: NotesService,
    ) {
        this.subscriptions = new Subscription();
    }

    ngOnInit() {
        this._setupForm();
        this.getNotes(0);
    }

    ngOnDestroy() {
        if (this.subscriptions) this.subscriptions.unsubscribe();
    }

    private _setupForm(): void {
        this.form = this.formBuilder.group({
            note: new FormControl('', [Validators.required]),
        });
    }

    private getNotes(page: number) {
        this.loading = true;
        this.hasErrors = false;
        this.subscriptions.add(
            this.notesService.getNotesPage(page, this.pageSize)
                .subscribe(notesPage => {
                    this.page = notesPage;
                    if (notesPage.results && notesPage.results.length) {
                        this.notes.push(...notesPage.results);
                    }
                    this.loading = false;
                },
                () => {
                    this.loading = false;
                    this.hasErrors = true;
                })
        );
    }

    public saveNote() {
        const noteValue = this.form.controls['note'].value || '';
        const isWhitespace = noteValue.trim().length === 0;
        if (this.form.valid && !isWhitespace) {
            this.saving = true;
            this.subscriptions.add(
                this.notesService.saveNote(this.form.value)
                    .subscribe(() => {
                        this.saving = false;
                        this.hasSavingError = false;
                        this.notes.unshift(new NotesModel({
                            createdByName: this.userName,
                            note: noteValue,
                            noteDate: new Date(),
                        }));
                        this.form.reset();
                    },
                    () => {
                        this.saving = false;
                        this.hasSavingError = true;
                    })
            );
        }
    }

    public loadMoreNotes(nextPage: number) {
        this.getNotes(nextPage);
    }

    public formatDate(date): string {
        return date ? moment(date).format('MM/DD/YYYY') : '';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/notes/notes-page.component.ts